
import Vue from 'vue'
import store from './../../store'
import notificationService from './../notification'
import logout from './logout'

export default (loginParams) => {
  if (loginParams) {
    return Vue.$http.post('auth/exit/', loginParams)
  } else {
    return Vue.$http.post('/auth/logoutall/')
      .finally(() => {
        return logout()
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/apiLogout.js